module.exports = " <div class=relative> <div class=\"bard-toolbar bard-toolbar-setting\" v-el:buttons> <button v-for=\"button in buttons\" :key=button.name v-tip :tip-text=button.text :class=\"{'active': enabled(button.name)}\" @click=toggleButton(button.name) v-html=button.html></button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/bard/BardButtonsSettingFieldtype.vue
// module id = 657
// module chunks = 0